import {useEffect} from 'react'
import {Navigate} from 'react-router-dom'
import {useAuth} from './core/Auth'
import {logoutSession} from './core/_requests'

export function Logout() {
  const {logout} = useAuth()
  useEffect(() => {
    // Clear the local session at once (so the Navigate below lands on the
    // login page), revoke the refresh token on the server (ADR-0019), and
    // only then reload — a reload while the request is in flight would abort
    // it. The component unmounts immediately; the chain runs regardless.
    logout()
    logoutSession()
      .catch(() => undefined)
      .finally(() => document.location.reload())
  }, [logout])

  // Navigate must not be wrapped in <Routes> — react-router v6 requires all
  // Routes children to be <Route>, and the invariant crash prevented the
  // logout effect from ever running.
  return <Navigate to='/auth/login' />
}
